/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionDifferenceRequest {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionDifferenceRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionDifferenceRequest>): AppSecopsSbomVersionDifferenceRequest {
        let obj = Object.assign(new AppSecopsSbomVersionDifferenceRequest(), model);
        AppSecopsSbomVersionDifferenceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionDifferenceRequest>): AppSecopsSbomVersionDifferenceRequest {
        if (!model) return null;
        return AppSecopsSbomVersionDifferenceRequest.newInstance(<AppSecopsSbomVersionDifferenceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionDifferenceRequest) {
        if (!obj) return;

        models.AppSecopsSbomVersionDifferenceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionDifferenceRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionDifferenceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * ID of the SBOM version against which component and vulnerability difference is fetched
     */
    compare_version_id: string;

}
